module.exports = __webpack_public_path__ + "img/preview.16a80760.png";